import React, { useEffect, useRef, useState } from 'react';
import './HairCheck.scss';

import Select from 'react-select';

import { getOffset, useSharedState } from '../../utils/helpers';
import { WebRTCsdkService } from '../../services/webrtcsdk-service';
import { container } from 'tsyringe';
import { PTApiService } from '../../services/ptapi-service';

import { ReactComponent as CameraIcon } from '../../../assets/icons/icon-settings-camera.svg';
import { debounce } from 'lodash';
import { CameraTooltip } from './CameraTooltip';

import AudioLevelMeter from '../layout/settings/AudioLevelMeter';

import { ReactComponent as AudioIcon } from '../../assets/icons/icon-settings-audio.svg';
import { ReactComponent as IconSpeaker } from '../../assets/icons/icon-speaker.svg';
import { SoundService } from '../../services/sound-service';
import { useNotTooFast } from '../hooks/useNotTooFast';
import { EventSubpage } from '../../pages/event/Event';
import { MeetingConnectionState } from '../../models/meetingClass';

import { useHistory, useLocation } from 'react-router-dom';

interface MicrophoneLevelProps {
  audioMute: boolean,
}

const MicrophoneLevel = (props: MicrophoneLevelProps) => {

  const [webRTCsdkService] = useState(container.resolve(WebRTCsdkService));
  const [sdkVolumeLevel] = useSharedState(webRTCsdkService.volumeLevel$);
  const [micVolume, setMicVolume] = useState(1);

  useEffect(() => {
    // console.log(Math.ceil(sdkVolumeLevel * 4));
    if (props.audioMute) {
      setMicVolume(0);
    } else {
      setMicVolume(Math.max(1, Math.min(Math.ceil(sdkVolumeLevel * 4), 4)));
    }
  }, [props.audioMute, sdkVolumeLevel])

  return (
    <div className={'mic-volume mic-volume-' + (micVolume)}></div>
  )
}


const HairCheck = ({ goToPage, channelReady }: { goToPage: (page: EventSubpage) => any, channelReady: boolean }) => {
  const [webRTCsdkService] = useState(container.resolve(WebRTCsdkService));
  const [soundService] = useState(container.resolve(SoundService));

  // const cameraReference = useRef(null);
  // const cameraOption = useRef(null);

  const [localCameras] = useSharedState(webRTCsdkService.localCameras$);
  const [cameraOptions, setCameraOptions] = useState([]);
  const [selectedCamera, setSelectedCamera] = useState(null);
  const [cameraStreamVisible, setCameraStreamVisible] = useState(false);

  const [audioTimer, setAudioTimer] = useState(null);

  const [devicePermissionError] = useSharedState(webRTCsdkService.devicePermissionError$);
  const [localMicrophones] = useSharedState(webRTCsdkService.localMicrophones$);
  const [localSpeakers] = useSharedState(webRTCsdkService.localSpeakers$);

  const [selectedSpeaker] = useSharedState(webRTCsdkService.selectedSpeaker$);

  const [selectedMic, setSelectedMic] = useState(null);
  const [micOptions, setMicOptions] = useState([]);

  const [selectedSpk, setSelectedSpk] = useState(null);
  const [speakerOptions, setSpeakerOptions] = useState([]);

  const [soundTesting, setSoundTesting] = useState(false);

  const [userVideoEnable, setUserVideoEnable] = useState(true);
  const [userAudioEnable, setUserAudioEnable] = useState(true);

  const [noMicrophoneWarning, setNoMicrophoneWarning] = useState(false);
  const [noCameraWarning, setNoCameraWarning] = useState(false);
  const [invalidCameraWarning, setInvalidCameraWarning] = useState(false);
  const [cameraDenied, setCameraDenied] = useState(false);
  const [invalidCameraPosition, setInvalidCameraPosition] = useState({ top: 0, left: 0 });


  const [meetingCnxState, setMeetingCnxState] = useState(MeetingConnectionState.IDLE);
  const [meetingState] = useSharedState(webRTCsdkService.meetingState$);


  const checkNotTooFast = useNotTooFast(800);

  const history = useHistory();
  const location = useLocation();

  useEffect(() => {

    webRTCsdkService.askPermissions();

    console.log('Call state', meetingState);
    setMeetingCnxState(meetingState.connexionState);
  }, [meetingState]);


  const computePosition = () => {
    // const offset = getOffset(cameraOption.current);
    // setInvalidCameraPosition({ top: offset.top - 230, left: offset.left + 40 });

    const width = window.innerWidth * 0.95 > 1280 ? 1280 : window.innerWidth * 0.95;
    const height = window.innerHeight * 0.7 > 720 ? 720 : window.innerHeight * 0.7;
    // if (cameraReference.current) {
    //   let marginLeft = 0;
    //   let marginTop = 0;
    //   if ((height / 9 * 16) > width) {
    //     marginLeft = (width - (height / 9 * 16)) / 2;
    //     marginTop = 0;
    //     cameraReference.current.style.height = '100%';
    //     cameraReference.current.style.width = 'unset';
    //   } else {
    //     marginTop = (height - width / 16 * 9) / 2;
    //     cameraReference.current.style.width = '100%';
    //     cameraReference.current.style.height = 'unset';
    //   }

    //   cameraReference.current.style.marginLeft = marginLeft + 'px';
    //   cameraReference.current.style.marginTop = marginTop + 'px';
    // }
  }


  useEffect(() => {
    if (devicePermissionError) {
      console.log('ERROR device is not allowed', devicePermissionError)
      if ("CAM_IN_USE" === devicePermissionError.code) {
        // display warning on camera
        setInvalidCameraWarning(true);
      }
      if ("CAM_MIC_DENIED" === devicePermissionError.code) {
        // display auth error on camera/mic
        setCameraDenied(true);
      }
    } else {
      setInvalidCameraWarning(false);
      setCameraDenied(false);

      // setTimeout(() => {
      //   onStartStudioWithSettings()
      // }, 10000);
    }
  }, [devicePermissionError])

  useEffect(() => {
    const debouncedHandleResize = debounce(computePosition, 1);

    computePosition();
    window.addEventListener('resize', debouncedHandleResize);

    // set initial state from previous state
    const prejoinMute = JSON.parse(localStorage.getItem('prejoinMute') || "{\"video\":false,\"audio\":true}");
    setUserVideoEnable(!prejoinMute.video);
    setUserAudioEnable(!prejoinMute.audio);

    // set these 2 to false to keep video and audio locally active
    webRTCsdkService.setVideoMuted(false);
    webRTCsdkService.setAudioMuted(false);

    webRTCsdkService.askPermissions();


    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, [])

  useEffect(() => {
    if (devicePermissionError) {
      console.log('ERROR device is not allowed', devicePermissionError)
      if ("CAM_IN_USE" === devicePermissionError.code ) {
        // display warning on camera
        setInvalidCameraWarning(true);
      }
    }
  }, [devicePermissionError])

  useEffect(() => {
    const debouncedHandleResize = debounce(computePosition, 1);

    computePosition();
    window.addEventListener('resize', debouncedHandleResize);
    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, [])


  const toggleUserVideo = () => {
    if (checkNotTooFast()) {
      const videoEnable = !userVideoEnable;
      setUserVideoEnable(videoEnable);
      // webRTCsdkService.setVideoMuted(!videoEnable);
      localStorage.setItem('prejoinMute',
        JSON.stringify({
          video: !videoEnable,
          audio: !userAudioEnable,
        })
      );
    }
  }
  const toggleUserAudio = () => {
    if (checkNotTooFast()) {
      const audioEnable = !userAudioEnable;
      setUserAudioEnable(audioEnable);
      // webRTCsdkService.setAudioMuted(!audioEnable);
      localStorage.setItem('prejoinMute',
        JSON.stringify({
          video: !userVideoEnable,
          audio: !audioEnable
        })
      );
    }
  }

  const onSelectCamera = (value, action) => {
    console.log('camera', value, action);
    setInvalidCameraWarning(false);
    setSelectedCamera(value);
    webRTCsdkService.setSelectedCamera(value.value);
  }


  useEffect(() => {
    console.log('CAMERAS', localCameras);
    const options = [];
    if (localCameras.length > 0) {
      localCameras.forEach(c => options.push({ value: c.id, label: c.name }));
      setCameraOptions(options);

      setTimeout(() => {
        // check if one of the cameras match last used
        let index = 0;
        const lastUsedDevices = JSON.parse(localStorage.getItem("lastUsedDevices") || "{}");
        if (lastUsedDevices && lastUsedDevices.camera) {
          index = localCameras.findIndex(s => s.name === lastUsedDevices.camera.name);
        }
        if (index < 0) index = 0;
        setSelectedCamera(options[index]);
        webRTCsdkService.setSelectedCamera(options[index].value);
        setTimeout(() => {
          setCameraStreamVisible(true);
        }, 2000);
      }, 2000);

      if (options.length > 1 || options[0].label !== 'Camera 1') {
        setNoCameraWarning(false);
      } else {
        setNoCameraWarning(true);
      }
    } else {
      // setNoCameraWarning(true);
    }
  }, [localCameras]);

  // useEffect(() => {
  //   webRTCsdkService.attachLocalVideo(cameraReference.current);
  // }, [cameraReference]);


  useEffect(() => {
    console.log('MICROPHONES', localMicrophones);
    const options = [];
    if (localMicrophones.length > 0) {
      localMicrophones.forEach(m => options.push({ value: m.id, label: m.name }));
      setMicOptions(options);

      // check if one of the microphone match last used
      let index = 0;
      const lastUsedDevices = JSON.parse(localStorage.getItem("lastUsedDevices") || "{}");
      if (lastUsedDevices && lastUsedDevices.microphone) {
        index = localMicrophones.findIndex(m => m.name === lastUsedDevices.microphone.name);
      }
      if (index < 0) index = 0;
      setSelectedMic(options[index]);
      webRTCsdkService.setSelectedMicrophone(options[index].value);
      if (options.length > 1 || options[0].label !== 'Microphone 1') {
        setNoMicrophoneWarning(false);
      } else {
        setNoMicrophoneWarning(true);
      }
    } else {
      // setNoMicrophoneWarning(true);
    }
  }, [localMicrophones]);

  useEffect(() => {
    console.log('SPEAKERS', localSpeakers);
    const options = [];
    if (localSpeakers.length > 0) {
      localSpeakers.forEach(s => options.push({ value: s.id, label: s.name }));
      setSpeakerOptions(options);

      // check if one of the speakers match last used
      let index = 0;
      const lastUsedDevices = JSON.parse(localStorage.getItem("lastUsedDevices") || "{}");
      if (lastUsedDevices && lastUsedDevices.speaker) {
        index = localSpeakers.findIndex(s => s.name === lastUsedDevices.speaker.name);
      }
      if (index < 0) index = 0;
      setSelectedSpk(options[index]);
      webRTCsdkService.setSelectedSpeaker(options[index].value);
    }
  }, [localSpeakers]);


  const onSoundTest = () => {
    if (audioTimer) {
      clearTimeout(audioTimer);
    }
    if (soundTesting) {
      setSoundTesting(false);
      soundService.testAudioStop();
      return;
    }
    setSoundTesting(true);
    soundService.testAudioStart(selectedSpeaker);
    setAudioTimer(setTimeout(() => {
      setSoundTesting(false);
      soundService.testAudioStop();
    }, 4000)); // SET duration of audio file
  }

  const onSelectMic = async (value, action) => {
    console.log('mic', value, action);
    setSelectedMic(value);
    webRTCsdkService.setSelectedMicrophone(value.value);
  }
  const onSelectSpeaker = (value, action) => {
    console.log('speaker', value, action);
    setSelectedSpk(value);
    webRTCsdkService.setSelectedSpeaker(value.value);
  }

  const onStartStudioWithSettings = () => {
    goToPage(EventSubpage.EVENT);
  }

  const reloadScreen = () => {
    history.push(location.pathname);
  }

  useEffect(() => {
    if (localCameras && localMicrophones && localSpeakers) {
      if (localCameras.length > 0 && localMicrophones.length && localSpeakers.length > 0 ) {
        onStartStudioWithSettings();
      }
    }
  }, [localCameras, localMicrophones, localSpeakers])

  return (
    <>
      {/* <div className="haircheck haircheck-background">
        <div className='header'>
          <div className='header-title'>Let&apos;s Go!</div>
          <div className='header-line'>Choose your audio and camera device</div>
        </div>
        <div className={`enter-btn ${channelReady ? '' : 'disabled'}`} onClick={onStartStudioWithSettings}>ENTER STUDIO</div>

        <div className="haircheck-wrapper">
          <div className="haircheck-container">

            <div className={"camera-preview " + (userVideoEnable ? '' : 'disabled')} >

                <video
                  style={{ height: '100%', opacity: cameraStreamVisible ? '1.0' : '0.0' }}
                  ref={cameraReference}
                  autoPlay
                />

            </div>

            <div className="footer"></div>

            {!userAudioEnable && userVideoEnable &&
              <div className="av-info">Mic is currently disabled</div>
            }
            {userAudioEnable && !userVideoEnable &&
              <div className="av-info">Camera is currently disabled</div>
            }
            {!userAudioEnable && !userVideoEnable &&
              <div className="av-info">Mic and Camera are currently disabled</div>
            }
          </div>

          <ul className="items">

            <li key="camera" ref={cameraOption}>
              <div className='icon icon-camera'></div>
              <div className="selector">
                <Select
                  menuPlacement="top"
                  className="basic-single"
                  classNamePrefix="select"
                  value={selectedCamera}
                  name="quality"
                  options={cameraOptions}
                  onChange={onSelectCamera}
                  isSearchable={false}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: '#373738', // hover
                      primary50: '#333334',  // selected
                      primary: '#242424',
                    },
                  })}
                />
              </div>
            </li>

            <li key="microphone">
              <div className='icon icon-microphone'></div>
              <div className="selector">
                <Select
                  menuPlacement="top"
                  className="basic-single"
                  classNamePrefix="select"
                  value={selectedMic}
                  name="microphone"
                  options={micOptions}
                  onChange={onSelectMic}
                  isSearchable={false}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: '#373738', // hover
                      primary50: '#333334',  // selected
                      primary: '#242424',
                    },
                  })}
                />
              </div>
              <div className="mic-level">
                <MicrophoneLevel audioMute={!userAudioEnable}></MicrophoneLevel>
              </div>
            </li>

            <li key="speaker">
              <div className='icon icon-speaker'></div>
              <div className="selector">
                <Select
                  menuPlacement="top"
                  className="basic-single"
                  classNamePrefix="select"
                  value={selectedSpk}
                  name="speaker"
                  options={speakerOptions}
                  onChange={onSelectSpeaker}
                  isSearchable={false}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: '#373738', // hover
                      primary50: '#333334',  // selected
                      primary: '#242424',
                    },
                  })}
                />
              </div>

              <div className={"speaker-test " + (soundTesting ? 'speaker-testing' : '')} onClick={onSoundTest}>
                <div>{soundTesting ? 'TESTING...' : 'TEST'}</div>
              </div>
            </li>

            <li className="state">

              <CameraTooltip title={userAudioEnable ? "Mute Audio" : "Unmute Audio"} enterDelay={500} placement='top'>
                <div className={"state-icon " + (userAudioEnable ? "state-icon-mic-on" : "state-icon-mic-off")} onClick={toggleUserAudio}>
                </div>
              </CameraTooltip>

              <CameraTooltip title={userVideoEnable ? "Disable Camera" : "Enable Camera"} enterDelay={500} placement='top'>
                <div className={"state-icon " + (userVideoEnable ? "state-icon-video-on" : "state-icon-video-off")} onClick={toggleUserVideo}>
                </div>
              </CameraTooltip>
            </li>


          </ul>
        </div>


        {(!cameraDenied && (noMicrophoneWarning || noCameraWarning)) &&
          <div className='warning'>
            <div className='warning-image'></div>
            <div className='warning-title'>
              Please allow access to your camera and microphone to continue
            </div>
          </div>
        }
        {invalidCameraWarning &&
          <div className='warning-camera' style={{ top: invalidCameraPosition.top + 'px', left: invalidCameraPosition.left + 'px' }}>
            <div className='warning-camera-image'></div>
            <div className='warning-camera-title'>
              This camera is not available or already used by another program
            </div>
          </div>
        }
        {cameraDenied &&
          <div className='denied-camera'>
            <div className='denied-camera-image'></div>
            <div className='denied-camera-title'>
              Please allow access to your camera and microphone to continue
              <div className='denied-camera-refresh' onClick={reloadScreen}>Refresh</div>
            </div>
          </div>
        }
      </div> */}

    </>
  )

}

export default HairCheck;
